import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BnNgIdleService } from 'bn-ng-idle';
import { CommonService } from './middleware/common/common.service';
import { SharedModule } from './middleware/shared/shared.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfirmDialogComponent } from './middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { EnvServiceProvider } from './env.service.provider';
import { EncryptionService } from './middleware/encryption/encryption.service';
import { ReusableClasses } from './middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from './middleware/common/status/status-constant';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {ToastrModule} from 'ngx-toastr';
import { Constants } from './middleware/common/reusableclassesAndFunctions/constants';
import {MatButtonModule} from '@angular/material/button';
import { Interceptor } from './middleware/authentication/interceptor/auth-interceptor';
import { EcmAuthgaurdGuard } from './middleware/authentication/authgaurd/ecm-authgaurd.guard';
import { ApiEndPointsUser } from './applicationModules/users/common/apiUrls/api-end-points';
//import { OnlynumberDirective } from './middleware/common/reusableclassesAndFunctions/number-d.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { DragdroptableComponent } from './middleware/common/dragdroptable/dragdroptable.component';
import { NestableModule } from 'ngx-nestable';
import { NgxMatDrpModule } from 'ngx-mat-daterange-picker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { CoreService } from './applicationModules/core/services/coreService/core.service';
import { ApiEndPointsCore } from './applicationModules/core/common/apiUrls/api-end-points-core';
import { ApiEndPointsSettings } from './applicationModules/settings/common/apiUrls/api-end-points-settings';
import { CoreVm, AddCoreVm, AddContactVm, AddCompanyVm } from './viewModels/core/core-vm';
//import { CalendarComponent } from './applicationModules/calendar/calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import {ImageDrawingModule} from 'ngx-image-drawing';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import { ApiEndPointsForms } from './applicationModules/eSignature/common/apiUrls/api-end-points-forms';
import { ApiEndPointsNotification } from './services/commonUtility/apiUrls/api-end-points-notification';
import { CookieService } from 'ngx-cookie-service';  
import { APP_INITIALIZER } from '@angular/core';
import { EnvService } from './env.service';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ConfirmDialogChangeComponent } from './middleware/common/reusableComponents/confirm-dialog-change/confirm-dialog-change.component';

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  //interactionPlugin
]);

@NgModule({
  declarations: [
    AppComponent,
    DragdroptableComponent,
    ConfirmDialogComponent,
    ConfirmDialogChangeComponent
    //CalendarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    SharedModule,
    MatButtonModule,
    MatDatepickerModule,
    NgxMatDrpModule,
    NgxDaterangepickerMd, 
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    NestableModule,
    FlexLayoutModule,
    FullCalendarModule ,
    ImageDrawingModule,
    ClipboardModule,
    ImageCropperModule,
    ToastrModule.forRoot(),
    NgxDaterangepickerMd.forRoot()
  ],
  providers: [
    CoreVm,
    AddCoreVm,
    AddContactVm,
    AddCompanyVm,
    ApiEndPointsCore,
    ApiEndPointsSettings,
    CoreService,
    EncryptionService,
    ReusableClasses,
    EnvServiceProvider,// Need to comment for multiple environment
    StatusConstant,
    BnNgIdleService,
    CommonService,
    ApiEndPointsUser,
    ApiEndPointsNotification,
    ApiEndPointsForms,
    Constants,
    CookieService,
    {provide:  HTTP_INTERCEPTORS, useClass: Interceptor,multi: true},
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (envService: EnvService) => () => envService.init(),
    //   deps: [EnvService],
    //   multi: true
    // },
    EcmAuthgaurdGuard
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
 }
